import { Card, Skeleton } from "@wa/ui";

/**
 * A document page that has not answered yet, in the shape of the page: a title,
 * the paper and the rail. The reader sees where the invoice will be instead of
 * a spinner in the middle of an empty screen.
 */
export function DocSkeleton({ label }: { label: string }) {
  return (
    <div role="status" aria-busy="true" aria-label={label}>
      <Skeleton className="mb-3 h-5 w-32" />
      <Skeleton className="h-9 w-64 max-w-full" />
      <Skeleton className="mb-6 mt-2.5 h-5 w-80 max-w-full" />
      <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1fr)_340px] lg:gap-6">
        <Card className="space-y-5 p-5 md:p-8">
          <div className="flex gap-10">
            <Skeleton className="h-10 w-24" />
            <Skeleton className="h-10 w-24" />
            <Skeleton className="h-10 w-32" />
          </div>
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-11/12" />
          <Skeleton className="h-4 w-4/5" />
          <Skeleton className="ml-auto h-20 w-56 max-w-full" />
        </Card>
        <Card className="space-y-4 p-6 max-lg:order-first">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-44" />
          <Skeleton className="h-11 w-full" />
        </Card>
      </div>
    </div>
  );
}
